import { ReactComponent as CloseSvg } from 'assets/close.svg';
import classNames from 'classnames';
import './styles.scss';

const BaseModal = ({ isVisible, handleClose, children }) => {
  const baseModal = classNames({
    baseModal: true,
    'baseModal--visible': isVisible,
  });
  return (
    <div className={baseModal}>
      <div className="baseModal__window">
        {children}
        <button className="baseModal__close" onClick={handleClose}>
          <CloseSvg />
        </button>
      </div>
    </div>
  );
};

export default BaseModal;
